const LOGIN_FORM = 'login';
const REGISTER_FORM = 'signup';

export { LOGIN_FORM, REGISTER_FORM };
